import { useState } from 'react';
import Portfolio from '../sections/Portfolio';
import CaseStudy from '../sections/CaseStudy';
import Clients from '../sections/Clients';
import CTA from '../sections/CTA';

export default function PortfolioPage() {
  const [activeCase, setActiveCase] = useState(null);

  function openCase(project) {
    setActiveCase(project);
    window.scrollTo(0, 0);
  }

  function closeCase() {
    setActiveCase(null);
    setTimeout(() => {
      document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' });
    }, 0);
  }

  if (activeCase) {
    return <CaseStudy project={activeCase} onBack={closeCase} />;
  }

  return (
    <>
      <div className="page-top-spacer" />
      <Portfolio onOpenCase={openCase} />
      <Clients />
      <CTA />
    </>
  );
}
